export const isNumeric = (n: any) => {
  const val = Number(n)
  return !isNaN(val) && isFinite(val);
};
